import { Http } from "@Services";

const logout = async (): Promise<any> => {
    try {
        await Http.Request({
            method: "POST",
            url: "/account/logout",
        });
    } catch (error) {
        throw Error(error.statusText);
    }
};

export default logout;
